import { Outlet } from "react-router-dom";

const RedgerlabWrapper = () => {
    return <Outlet />;
};

export default RedgerlabWrapper;
